import CommonStore from './commonStore';
export const stores = {
  CommonStore,
};